import resolver, {ResolverSettings} from './utils/resolver';
import {InsuranceSetup} from '../utils';

class PropertyProtectionApi {
  ENDPOINTS = {
    getPropertyProtectionsByReservation: (reservationId: string) =>
      `insurance/property-protection-for-reservation/${reservationId}/`,
    insuranceSetup: (id = '') => `insurance-setup/${id ? id + '/' : ''}`,
  };

  async getPropertyProtectionsByReservation<T>(
    reservationId: string,
    resolverSettings?: ResolverSettings,
  ) {
    const response = await resolver<T>(
      this.ENDPOINTS.getPropertyProtectionsByReservation(reservationId),
      null,
      resolverSettings,
    );
    return response.body;
  }

  async mutateInsuranceSetup<T>(
    {id, ...payload}: Partial<InsuranceSetup>,
    resolverSettings?: ResolverSettings,
  ) {
    const response = await resolver<T>(
      this.ENDPOINTS.insuranceSetup(id),
      {
        method: id ? 'PATCH' : 'POST',
        body: JSON.stringify(payload),
      },
      {version: 4, ...resolverSettings},
    );
    return response.body;
  }

  async getInsuranceSetup<T>(id: string, resolverSettings?: ResolverSettings) {
    const response = await resolver<T>(this.ENDPOINTS.insuranceSetup(id), null, {
      version: 4,
      ...resolverSettings,
    });
    return response.body;
  }
}

export {PropertyProtectionApi};
